import React from 'react'
import PropTypes from 'prop-types'
import ReactImgix from 'react-imgix'
import classNames from 'classnames'

import styles from './title-treatment-image.css'

const TitleTreatmentImage = ({ src, imageStyle, alt }) => {
  if (!src) return null

  return (
    <ReactImgix
      className={classNames(styles.titleTreatment, imageStyle)}
      src={src}
      width={580}
      height={220}
      imgixParams={{
        auto: 'format',
        q: 80
      }}
      htmlAttributes={{
        alt
      }}
    />
  )
}

TitleTreatmentImage.propTypes = {
  src: PropTypes.string.isRequired,
  imageStyle: PropTypes.string,
  alt: PropTypes.string
}

TitleTreatmentImage.defaultProps = {
  imageStyle: '',
  alt: ''
}

export default TitleTreatmentImage
